import { render } from "./Activitytable.vue?vue&type=template&id=746281b4"
import script from "./Activitytable.vue?vue&type=script&lang=js"
export * from "./Activitytable.vue?vue&type=script&lang=js"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__